var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('img',{attrs:{"width":"100%","src":"/img/congelamento.jpeg","alt":"","srcset":""}})])
}]

export { render, staticRenderFns }